var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12057_1815)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.95654,
    y: 1,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#014C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7899 22.5V9.16667C22.7899 8.72464 22.6143 8.30072 22.3017 7.98816C21.9892 7.67559 21.5652 7.5 21.1232 7.5H12.7899C12.3478 7.5 11.9239 7.67559 11.6114 7.98816C11.2988 8.30072 11.1232 8.72464 11.1232 9.16667V22.5M22.7899 22.5H11.1232M22.7899 22.5H24.4565M22.7899 22.5H18.6232M11.1232 22.5H9.45654M11.1232 22.5H15.2899M18.6232 22.5V18.3333C18.6232 18.1123 18.5354 17.9004 18.3791 17.7441C18.2229 17.5878 18.0109 17.5 17.7899 17.5H16.1232C15.9022 17.5 15.6902 17.5878 15.534 17.7441C15.3777 17.9004 15.2899 18.1123 15.2899 18.3333V22.5M18.6232 22.5H15.2899M14.4565 10.8333H15.2899M14.4565 14.1667H15.2899M18.6232 10.8333H19.4565M18.6232 14.1667H19.4565",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12057_1815",
    x: 0.956543,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12057_1815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12057_1815",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgSelect);
export default __webpack_public_path__ + "static/media/org-select.49875770fbb381624ce620cc26f69f20.svg";
export { ForwardRef as ReactComponent };